import { render } from "./ListEmergencyPage.vue?vue&type=template&id=603c0bc0&ts=true"
import script from "./ListEmergencyPage.vue?vue&type=script&lang=ts"
export * from "./ListEmergencyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__